import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { LayerTypeIconSource } from "./eventLabels"

export type EventIconBadge = "success" | "failure"

const Badge = ({ badge }: { badge: EventIconBadge }) => (
    <div className="absolute -top-1 -right-1 drop-shadow-[0px_1px_1px_rgba(12,12,15,0.95)]">
        <Icons.CustomIcon
            Icon={badge === "success" ? Icons.Checkmark : Icons.Exclamation}
            size={{ width: 12, height: 12 }}
            className={classNames(
                "rounded-full text-white",
                badge === "success" ? "bg-green-500" : "bg-red-500"
            )}
        />
    </div>
)

export const EventTypeIcon = ({
    source,
    badge,
    iconClassName,
}: {
    source: LayerTypeIconSource
    badge?: EventIconBadge
    iconClassName?: string
}) => (
    <div className="relative shrink-0 w-8 h-8">
        <div className="w-8 h-8 rounded-lg bg-gray-800 flex items-center justify-center overflow-hidden">
            {"url" in source ? (
                <img src={source.url} alt="" className="w-5 h-5" />
            ) : (
                <Icons.Icon Icon={source} iconClassName={iconClassName} />
            )}
        </div>
        {badge && <Badge badge={badge} />}
    </div>
)
